export enum MedicareQuoteType {
  'Medicare Supplement' = 'medicareSupplement',
  'Medicare Advantage' = 'medicareAdvantage',
  'Medicare Prescription' = 'medicarePrescription'
}
